<script>
	import TreeView from "./TreeView.svelte";

	export let api;
	export let store;

	const state = store.getReactive();

	const rTreeTasks = state.treeTasks;
	const rComponentId = state.id;

</script>

<TreeView
	on:action
	data={$rTreeTasks}
	id={$rComponentId}
	{state}
	{store}
	{api} />
